import { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';

import CustomModal from '@/resources/components/global/CustomModal';
import MoneyDisplay from '@/resources/components/global/MoneyDisplay/MoneyDisplay';
import { useDevice } from '@/resources/hooks/useDevice';
import { useWebContext } from '@/resources/hooks/useWebContext';
import { addCartItem } from '@/routes/order';
import { IBestCombo, ICartCombo } from '@/store/ducks/combos/types';
import { ICartProduct } from '@/store/ducks/order/types';
import { IProduct } from '@/store/ducks/products/types';

import { formatToBestCombo, getComboInfo, submitComboPromotion } from '../../utils/comboUtils';
import { getQuantitiesOnEdit } from '../utils';

export function ComboAddModal({
  show,
  onClose,
  product,
}: {
  show: boolean;
  onClose: () => void;
  product: IProduct | undefined;
}) {
  const { order } = useWebContext();
  const { device } = useDevice();

  const [quantities, setQuantities] = useState<Record<number, number>>({});

  const cart = order?.cart;

  const MainProduct: IProduct | undefined = product;

  const formattCombo: IBestCombo | undefined = formatToBestCombo(
    cart?.combos?.find((combo: ICartCombo) => combo.id === MainProduct?.combo_id),
  );

  const { combo_price, products_total } = getComboInfo({ best_combo: formattCombo } as {
    best_combo: IBestCombo;
  });

  const getProducts: () => ICartProduct[] | undefined = () => {
    const comboProducts = order?.cart.products.filter(
      (p) => p.combo_seq_id && p.combo_id === MainProduct?.combo_id,
    );

    if (!comboProducts) return;

    const comboGroups = comboProducts?.reduce((groups, product) => {
      const comboSeqId = product.combo_seq_id;
      if (!groups[comboSeqId]) {
        groups[comboSeqId] = [];
      }
      groups[comboSeqId]?.push(product);
      return groups;
    }, {} as Record<number, typeof comboProducts>);

    // eslint-disable-next-line consistent-return
    return Object.entries(comboGroups).flatMap(([, products]) => products);
  };

  useEffect(() => {
    if (getProducts()) getQuantitiesOnEdit(getProducts() as ICartProduct[], setQuantities);
  }, [MainProduct]);

  const handleSubmitComboPromotion = async (): Promise<void> => {
    const result = await submitComboPromotion({
      quantities,

      comboId: MainProduct?.combo_id || 0,
      onClose,
      orderId: order?.id,
    });

    if (!result.success) {
      console.error('Combo promotion failed:', result.error);
    }
  };

  return (
    <CustomModal show={show} onHide={onClose} size="md" centered>
      <Modal.Body className="p-1 pt-3">
        <p className="text-center d-flex flex-column" style={{ fontSize: '1.25rem' }}>
          Deseja adicionar mais um
          <strong>
            Combo{' '}
            {cart?.combos?.find((combo: ICartCombo) => combo.id === MainProduct?.combo_id)?.name}
          </strong>
          <span>
            Economize mais <MoneyDisplay value={products_total - combo_price} /> adicionando mais um
            combo!
          </span>
        </p>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-center flex-md-row flex-column-reverse w-100">
        <Button
          variant="outline-secondary"
          onClick={() => {
            if (product) {
              addCartItem(order?.id as number, {
                product_id: product?.product_id,
                quantity: 1,
                ean: product?.ean,
                options: [],
              });
            }
            onClose();
          }}
          style={{ fontSize: '1rem', width: device === 'desktop' ? '16.469rem' : '22.375rem' }}
        >
          Não, apenas o produto
        </Button>
        <Button
          variant="primary"
          onClick={() => handleSubmitComboPromotion()}
          style={{ fontSize: '1rem', width: device === 'desktop' ? '16.469rem' : '22.375rem' }}
        >
          Sim
        </Button>
      </Modal.Footer>
    </CustomModal>
  );
}
